import { Button } from '@monorepo/shared/componentsV2/Button';
import { ButtonsGroup } from '@monorepo/shared/componentsV2/ButtonsGroup';
import { Anchor } from '@monorepo/shared/componentsV2/Link';
import { Toolbar } from '@monorepo/shared/componentsV2/Toolbar';
import { viewsProductGuideUrl } from '@monorepo/shared/externalLinks/productGuide';
import { useHasProjectSettingsPermissions } from '@monorepo/shared/hooks/permissions/useHasPermissions';
import React from 'react';
import { useParams } from 'react-router-dom';

interface ViewsToolbarProps {
  onCreateNewView: () => void;
  isLoading: boolean;
}

export function ViewsToolbar({
  onCreateNewView,
  isLoading,
}: ViewsToolbarProps) {
  const { projectId } = useParams();
  const canEditViews = useHasProjectSettingsPermissions(projectId);

  return (
    <Toolbar
      rightActions={
        <ButtonsGroup>
          <Anchor color="grey" href={viewsProductGuideUrl} target="_blank">
            Learn about Reports
          </Anchor>
          {canEditViews && (
            <Button
              color="primary"
              onClick={onCreateNewView}
              variant="contained"
              disabled={isLoading}
            >
              Create new Report
            </Button>
          )}
        </ButtonsGroup>
      }
      size="small"
      variant="noDropShadow"
    />
  );
}
